<span
  class="sz-delta-chip"
  [class.sz-delta-chip--positive]="value() > 0"
  [class.sz-delta-chip--negative]="value() < 0"
  [class.sz-delta-chip--zero]="value() === 0">
  <span class="sz-delta-chip__value">{{ value() > 0 ? '+' : '' }}{{ value() }}%</span>
  <span class="sz-delta-chip__suffix">{{ suffix() }}</span>
</span>
